import ReactTable from './react-table.vue';

export default ReactTable;